import { type PayloadAction, createSlice } from "@reduxjs/toolkit";

interface INetworkState {
  network: string;
}

const initialState: INetworkState = {
  network: "Base",
};

const NetworkSlice = createSlice({
  name: "network",
  initialState,
  reducers: {
    setNetwork: (state, action: PayloadAction<string>) => {
      state.network = action.payload;
    },
    resetNetwork: (state) => {
      state.network = "Base";
    },
  },
});

export const { setNetwork } = NetworkSlice.actions;

export default NetworkSlice.reducer;
